import {action, observable, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import manualOutboundCallAPI from '../apis/manualOutboundCallAPI'
import alertMessage from '../utils/alertMessage'

export default class ManualOutboundCallStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeLog = PAGE_SIZE_DEFAULT
  @observable pageNoLog = 1
  @observable currIndexLog = 0
  @observable inBoundNameList = []

  /*SearchResult start*/
  @observable searchItem = {
    'marketGroupId': '',
    'logUser': '',
    'startTime': '',
    'endTime': '',
    'syncStatus': '',
    'isPowerUser' : false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []

  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await manualOutboundCallAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  //下拉列表
  @observable groupList = []
  @action
  async onGetGroup(params) {
    this.groupList = []
    try {
      const response = await manualOutboundCallAPI.getGroup(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.groupList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  // 操作人列表
  @observable auditLogsUserList = []
  @action
  async getAuditUsers() {
    this.auditLogsUserList = []
    try {
      const response = await manualOutboundCallAPI.getAuditUsers()
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.auditLogsUserList = data
        } else {
          alertMessage.error('Failed！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  //Status 下拉列表
  @observable statusList = []
  @action
  async onGetStatus(params) {
    this.statusList = []
    try {
      const response = await manualOutboundCallAPI.getStatus(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.statusList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  //问卷列表
  @observable isFetchingRemarkTemplate = false
  @observable remarkTemplateList = []
  @action
  async onGetRemarkTemplate() {
    this.isFetchingRemarkTemplate = true
    this.remarkTemplateList = []
    try {
      const response = await manualOutboundCallAPI.getRemarkTemplate()
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        this.isFetchingRemarkTemplate = false
        if (code === 0) {
          this.remarkTemplateList = data || []
        } else {
          alertMessage.error('Failed！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetchingRemarkTemplate = false
      })
    }
  }
  /*get remark template detail*/
  @observable remarkTemplateObj = null
  @action
  async onGetRemarkTemplateAction(params) {
    this.isFetchingRemarkTemplateAction = true
    this.remarkTemplateObj = null
    try {
      const response = await manualOutboundCallAPI.getRemarkTemplateAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data, code} = response.data
        if (code === 0) {
          this.isFetchingRemarkTemplateAction = false
          this.remarkTemplateObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetchingRemarkTemplateAction = false
      })
    }
  }
  /*get history*/
  @observable historyList = []
  @action
  async onGetHistoryAction(params) {
    this.historyList = []
    try {
      const response = await manualOutboundCallAPI.getHistoryAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data, code} = response.data
        if (code === 0) {
          this.historyList = data || []
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }
  @action
  onChangeHistoryList(value) {
    this.historyList = value
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }
  /*SearchResult end*/

  /*get permission*/
  @observable detailsObj = null
  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await manualOutboundCallAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data, code} = response.data
        if (code === 0) {
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*add permission*/
  @observable isFetchingAdd = false
  @action
  async onAddJobAction(params, title, isClose) {
    this.isFetchingAdd = true
    try {
      const response = await manualOutboundCallAPI.addAction(params)
      runInAction(() => {
        this.isFetchingAdd = false
        if (response.data?.code === 0) {
          if(!isClose){
            alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
            this.onSearchJobAction(this.searchItem)
          }
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingAdd = false
      })
    }
  }

  /*delete permission*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await manualOutboundCallAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      ...this.searchItem,
      'page': pageNo,
      'size': pageSize,
    })
  }

  /*get cti token*/
  @observable isFetchingToken = false
  @observable ctiToken = null
  @action
  async onGetTokenAction(params) {
    this.isFetchingToken = true
    try {
      const response = await manualOutboundCallAPI.getTokenLogin(params)
      runInAction(() => {
        const {data, code} = response.data
        if (code === 0) {
          this.ctiToken = data.token || null
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
    }
  }

  // 席位登出
  @action
  async onLogoutTokenAction(params) {
    try {
      return await manualOutboundCallAPI.getTokenLogout(params)
    } catch (err) {
      alertMessage.error(err.message)
    }
  }

  // 初始化数据：并行执行三个请求，全部完成后设置 isFetchingToken = false
  // 改为执行前两个请求 token在拨号时获取
  @action
  async initAllData(params) {
    this.isFetchingToken = true
    try {
      await Promise.all([
        this.onGetGroup(params),
        this.onGetRemarkTemplate(),
        // this.onGetTokenAction()
      ])
      runInAction(() => {
        this.isFetchingToken = false
      })
    } catch (err) {
      runInAction(() => {
        this.isFetchingToken = false
      })
    }
  }
}
